export var HARD_LOGIN_FAILURE = 'User must be hard-logged in.';
export var NOT_ELIGIBLE = 'User not eligible for 1-click.';
export var CONTENTFUL_ERROR = 'Error fetching content from Contentful';
export var USER_REDIRECT = 'User redirected';
export var USER_REDIRECT_MESSAGE = 'User got redirected to ';
export var NOTIFICATION_BANNER_ID = 'NotificationBanner';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/OneClick/constants.js
// module id = 877
// module chunks = 11